const clientFailedSharesConstants = {
    GET_CLIENT_FAILED_SHARES_REQUEST: "GET_CLIENT_FAILED_SHARES_REQUEST",
    GET_CLIENT_FAILED_SHARES_SUCCESS: "GET_CLIENT_FAILED_SHARES_SUCCESS",
    GET_CLIENT_FAILED_SHARES_FAILURE: "GET_CLIENT_FAILED_SHARES_FAILURE",
    RESET_CLIENT_FAILED_SHARES: "RESET_CLIENT_FAILED_SHARES",
};

export default clientFailedSharesConstants;
